import getConfig from "next/config";
import Link from "next/link";
import ArrowDown from "@components/Icons/ArrowDown";
import replaceAll from "string.prototype.replaceall";
import PromoMainMenuSubCategory from "@containers/Promo/PromoMobileMenu/PromoMobileMenuSubCategory";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

// Brico: categories in black (white on dark-theme campaigns, where an explicit
// colour would override the menu wrapper's white), selected category in brand
// red, first letter in Macan Stencil.
const categoryClass = isBricoStore
  ? "text-ironBlack group-with-promoDarkTheme:text-white"
  : "";
const activeCategoryClass = isBricoStore ? "text-red-brand" : "text-green";

const renderName = (label) =>
  isBricoStore ? (
    <span className="bd-claim inline-block first-letter:uppercase">{label}</span>
  ) : (
    label
  );

const PromoMainMenuCategory = ({
  currentPageCategory,
  id,
  name,
  link,
  subcategories,
  activeTree,
  onSetActive,
  isActive,
  slug,
}) => (
  <div>
    {!isActive && !subcategories && currentPageCategory !== id && (
      <div className={`py-3 ${categoryClass}`}>
        <Link href={`${link}`}>
          <a className="block font-semibold">{renderName(name)}</a>
        </Link>
      </div>
    )}

    {((!isActive && subcategories) ||
      (!isActive && currentPageCategory === id)) && (
      <div
        className={`flex justify-between items-center py-3 cursor-pointer font-semibold ${
          categoryClass
        }`}
        onClick={() =>
          onSetActive({
            categorySlug: slug,
          })
        }
      >
        <a
          href={`${link}`}
          title=""
          onClick={(event) => event.preventDefault()}
          className="block"
        >
          {renderName(name)}
        </a>

        <ArrowDown width="10px" />
      </div>
    )}

    {isActive && !subcategories && (
      <div
        className={`flex justify-between items-center py-3 font-semibold ${
          activeCategoryClass
        }`}
      >
        <a
          href={`${link}`}
          title=""
          onClick={(event) => event.preventDefault()}
          className="block"
        >
          {renderName(name)}
        </a>
      </div>
    )}

    {isActive && subcategories && (
      <>
        <div
          className={`flex justify-between items-center py-3 cursor-pointer border-b border-[#A2A2A2] font-semibold ${
            activeCategoryClass
          }`}
          onClick={() =>
            onSetActive({
              categorySlug: null,
            })
          }
        >
          <a
            href={`${link}`}
            title=""
            onClick={(event) => event.preventDefault()}
            className="block"
          >
            {renderName(name)}
          </a>

          <div className="rotate-180">
            <ArrowDown width="10px" />
          </div>
        </div>

        <ul className="list-none ml-4">
          {subcategories.map((subcategory, index) => {
            const isSubCategoryActive =
              activeTree.subCategorySlug === subcategory.slug;

            return (
              <li
                key={subcategory.id}
                className={`${
                  index + 1 !== subcategories.length
                    ? "border-b border-[#A2A2A2]"
                    : ""
                }`}
              >
                <PromoMainMenuSubCategory
                  id={subcategory.id}
                  link={replaceAll(`${link}/${subcategory.slug}/`, "//", "/")}
                  name={subcategory.name}
                  slug={subcategory.slug}
                  subcategories={subcategory.subcategories}
                  filters={subcategory.filters}
                  isActive={isSubCategoryActive}
                  activeTree={activeTree}
                  onSetActive={(params) =>
                    onSetActive({
                      categorySlug: slug,
                      ...params,
                    })
                  }
                />
              </li>
            );
          })}
        </ul>
      </>
    )}
  </div>
);

export default PromoMainMenuCategory;
